import { GHLLanguageKeys as r } from "./ghl-ui.es285.js";
import e from "./ghl-ui.es821.js";
const f = {
  name: r.frenchFrance,
  locale: e
};
export {
  f as date_fr_FR
};
